var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgForbidden(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.14,
    width: 150,
    height: 150,
    rx: 75,
    fill: "#00A9E0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97.5191 111C101.34 111 104.448 107.961 104.448 104.225V65.2691C104.448 64.3341 103.674 63.5754 102.716 63.5754H94.0546V54.8645C94.0546 44.592 85.5061 36.2334 75.0001 36.2334C64.4942 36.2334 55.9456 44.592 55.9456 54.8645V63.5754H47.2845C46.3266 63.5754 45.5522 64.3341 45.5522 65.2691V104.225C45.5522 107.961 48.6599 111 52.4812 111H97.5191ZM59.4099 54.8656C59.4099 46.4613 66.4029 39.622 74.9999 39.622C83.597 39.622 90.59 46.4613 90.59 54.8656V63.5765H59.4099V54.8656ZM100.983 66.961H49.0164V104.223C49.0164 106.091 50.5702 107.611 52.4808 107.611H97.5187C99.4294 107.611 100.983 106.091 100.983 104.223V66.961ZM73.2678 86.9776V95.7579C73.2678 96.6929 74.0421 97.4517 75.0001 97.4517C75.958 97.4517 76.7323 96.6929 76.7323 95.7579V86.9776C78.7434 86.2764 80.1967 84.4133 80.1967 82.208C80.1967 79.4066 77.8652 77.1268 75.0001 77.1268C72.135 77.1268 69.8034 79.4066 69.8034 82.208C69.8034 84.4133 71.2567 86.2764 73.2678 86.9776ZM76.7319 82.2044C76.7319 81.2712 75.9559 80.5107 74.9997 80.5107C74.0435 80.5107 73.2675 81.2712 73.2675 82.2044C73.2675 83.1377 74.0435 83.8981 74.9997 83.8981C75.9559 83.8981 76.7319 83.1377 76.7319 82.2044Z",
    fill: "#00A9E0"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgForbidden);
export default __webpack_public_path__ + "static/media/forbidden.acc8cadae8f4944751893c6a4ed97676.svg";
export { ForwardRef as ReactComponent };